import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Face3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"face_3"}/>
}
